import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import StudentsPage from "../../pages/student/StudentsPage";
import AuthPage from "../../pages/auth/AuthPage";
import ReportsPage from "../../pages/reports/ReportsPage";
import { TeacherRole } from "../../shared/types/teacher";
import PublicRoute from "./PublicRoute";
import TeachersPage from "../../pages/teacher/TeachersPage";
import StudentPage from "../../pages/student/StudentPage";
import AgreementsPage from "../../pages/agreements/AgreementsPage";
import AgreementPage from "../../pages/agreements/AgreementPage";
import AgreementStudentHistoryPage from "../../pages/agreements/AgreementStudentHistoryPage";
import LessonPage from "../../pages/lessons/LessonPage";
import ConfigurationsPage from "../../pages/configuration/ConfigurationsPage";

export const AppRoutes: React.FC = () => {
    return (
        <Routes>
            <Route element={<PublicRoute/>}>
                <Route path="/login" element={<AuthPage/>}/>

                <Route path="*" element={<Navigate to="/login" replace/>}/>
            </Route>

            <Route element={<ProtectedRoute/>}>
                <Route path="/students" element={<StudentsPage/>}/>
                <Route path="/students/:id" element={<StudentPage/>}/>
                <Route path="/reports" element={<ReportsPage/>}/>
                <Route path="/agreements" element={<AgreementsPage/>}/>
                <Route path="/agreements/:id" element={<AgreementPage/>}/>
                <Route path="/agreements/:agreementId/lessons/:id" element={<LessonPage/>}/>

                <Route element={<ProtectedRoute roleRequired={TeacherRole.ADMIN}/>}>
                    <Route path="/teachers" element={<TeachersPage/>}/>
                    <Route path="/configurations" element={<ConfigurationsPage/>}/>
                    <Route path="/agreements/:agreementId/students/:studentId" element={<AgreementStudentHistoryPage/>}/>
                </Route>

                <Route path="*" element={<Navigate to="/students" replace/>}/>
            </Route>
        </Routes>
    );
};